import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

/**
 * AccountDeletedPage
 * Lightweight 3-second interstitial shown after a successful account deletion.
 * Mounted at `/account-deleted` (public route — the Clerk session is already gone
 * by the time the user lands here, so this page must render without auth).
 *
 * Designed to read clearly in the App Store reviewer's screen recording.
 */
const REDIRECT_MS = 3000;

const AccountDeletedPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => navigate('/auth/login', { replace: true }), REDIRECT_MS);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div
      className="min-h-screen bg-white flex items-center justify-center px-6"
      data-testid="account-deleted-page"
    >
      <div className="max-w-sm w-full text-center">
        <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-emerald-50 flex items-center justify-center">
          <CheckCircle2 className="w-9 h-9 text-emerald-600" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Your account has been permanently deleted
        </h1>
        <p className="text-sm text-gray-500">
          All of your data has been removed from I Need Numbers. Redirecting you to sign-in…
        </p>
      </div>
    </div>
  );
};

export default AccountDeletedPage;
